module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box2",
    class: {
      'fixed': _vm.isFixed
    }
  }, [_c('div', {
    staticClass: "bb"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "a",
    class: {
      active: 0 === _vm.menuIndex
    },
    on: {
      "click": function($event) {
        _vm.menuEvent(0)
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("网站首页")]), _vm._v(" "), _c('span', {
    staticClass: "english"
  }, [_vm._v("Home")])]), _vm._v(" "), _vm._l((_vm.menuList), function(item, index) {
    return _c('div', {
      staticClass: "a",
      class: {
        active: index + 1 === _vm.menuIndex
      },
      on: {
        "click": function($event) {
          _vm.menuEvent(index + 1)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "english"
    }, [_vm._v(_vm._s(item.english))])])
  })], 2)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.menuList), function(listItem, index1) {
    return _c('div', {
      staticClass: "kuai-box",
      class: {
        bgfff: index1 % 2 === 1
      },
      attrs: {
        "id": index1 + 1
      }
    }, [_c('div', {
      staticClass: "kuai-main"
    }, [_c('h3', [_vm._v(_vm._s(listItem.text))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(listItem.desc))]), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_vm._l((listItem.items), function(item, index2) {
      return _c('div', {
        staticClass: "item",
        class: {
          nom: (index2 + 1) % 3 === 0
        },
        on: {
          "click": function($event) {
            _vm.location(item)
          }
        }
      }, [_c('div', {
        staticClass: "shadow"
      }), _vm._v(" "), _c('div', {
        staticClass: "img-box"
      }, [_c('img', {
        class: {
          img: index1 === 1
        },
        attrs: {
          "src": item.img
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "imgma-box",
        attrs: {
          "if": "item.imgma"
        }
      }, [_c('img', {
        staticClass: "imgma",
        attrs: {
          "src": item.imgma
        }
      })])]), _vm._v(" "), _c('div', {
        class: {
          descinfo1: index1 === 1, descinfo: index1 !== 1
        }
      }, [_c('div', {
        staticClass: "a-box"
      }, [_c('h6', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('p', {
        class: {
          height: index1 === 0
        },
        attrs: {
          "title": item.content
        }
      }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), (index1 === 0) ? _c('div', {
        staticClass: "button"
      }, [_c('div', {
        staticClass: "btn",
        on: {
          "click": function($event) {
            _vm.officeSitEvent(item, false)
          }
        }
      }, [_vm._v("查看[官网]")]), _vm._v(" "), _c('div', {
        staticClass: "btn",
        on: {
          "click": function($event) {
            _vm.officeSitEvent(item, true)
          }
        }
      }, [_vm._v("查看[模仿]")])]) : _vm._e()])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "kong"
    })], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "height": "70px"
      }
    })])
  }), _vm._v(" "), _vm._m(2)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "logo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide bg1"
  }, [_vm._v("这世上最快的捷径就是脚踏实地")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide bg2"
  }, [_vm._v("笔耕不掇，天道酬勤")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide bg3"
  }, [_vm._v("十年磨一剑，一朝试锋芒")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "bo"
  }, [_vm._v("划船不用浆，一生全靠浪！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58663a66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 5
// module chunks = 1